<template>
  <div class="search-box">
    <el-form ref="searchFormRef" :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="预约单号" prop="orderNo">
        <el-input v-model="formInline.orderNo" clearable placeholder="请输入" />
      </el-form-item>
      <el-form-item label="预约人" prop="packageName">
        <el-input v-model="formInline.packageName" clearable placeholder="请输入" />
      </el-form-item>
      <el-form-item label="预约日期" prop="date">
        <el-date-picker v-model="formInline.date" format="YYYY-MM-DD" value-format="YYYY-MM-DD" type="daterange"
          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="订单状态" prop="orderStatus">
        <el-select v-model="formInline.orderStatus" clearable placeholder="请选择">
          <el-option label="预约中" :value="0" />
          <el-option label="已预约" :value="1" />
          <el-option label="已到检" :value="2" />
          <el-option label="已取消" :value="3" />
          <el-option label="已完成" :value="4" />
          <el-option label="未到检" :value="5" />
          <el-option label="预约失败" :value="6" />
        </el-select>
      </el-form-item>
      <el-form-item label="订单类型" prop="orderType">
        <el-select v-model="formInline.orderType" clearable placeholder="请选择">
          <el-option label="个人体检" value="0" />
          <el-option label="企业体检" value="1" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button @click="onReset(searchFormRef)">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
  <div class="table-box">
    <div class="table-btns">
      <el-button type="primary" :icon="Upload" @click="orderExportBtn">订单导出</el-button>
    </div>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="orderNo" label="预约单号" align="center" />
      <el-table-column prop="healthUserName" label="预约人" align="center" />
      <el-table-column prop="phone" label="手机号" align="center" />
      <el-table-column prop="packageName" label="预约套餐" align="center" />
      <el-table-column prop="storeName" label="预约门店" align="center" />
      <el-table-column prop="setMenuType" label="预约类型" align="center" />
      <el-table-column prop="appointmentTime" label="预约时间" align="center" />
      <el-table-column prop="timePeriodValue" label="预约时段" align="center" />
      <el-table-column prop="createTime" label="创建时间" align="center" />
      <el-table-column prop="orderStatus" label="订单状态" align="center">
        <template #default="scope">
          <span v-if="scope.row.orderStatus == 0">预约中</span>
          <span v-if="scope.row.orderStatus == 1" class="blue">已预约</span>
          <span v-if="scope.row.orderStatus == 2">已到检</span>
          <span v-if="scope.row.orderStatus == 3" class="red">已取消</span>
          <span v-if="scope.row.orderStatus == 4" class="success">已完成</span>
          <span v-if="scope.row.orderStatus == 5" class="yellow">未到检</span>
          <span v-if="scope.row.orderStatus == 6" class="red" style="font-weight: bold;">预约失败</span>
        </template>
      </el-table-column>
      <el-table-column prop="orderType" label="订单类型" align="center">
        <template #default="scope">
          <span v-if="scope.row.orderType == 0">个人体检</span>
          <span v-if="scope.row.orderType == 1">企业体检</span>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作" align="center" width="120">
        <template #default="scope">
          <el-button type="primary" size="small" v-if="scope.row.orderStatus == 0 || scope.row.orderStatus == 5" @click="cancel(scope.row)">取消订单</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pagination" v-model:current-page="currentPage" v-model:page-size="pageSize"
      :page-sizes="[10, 50, 100, 200]" :small="small" :background="background"
      layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" />
  </div>
</template>

<script setup>
import { reactive, ref, onMounted, nextTick } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { Upload, ArrowRightBold, ArrowDownBold } from "@element-plus/icons-vue";
import service from "@/http/request.js";
const tableData = ref([]);

const formInline = reactive({
  orderNo: null,
  packageName: null,
  orderStatus: null,
  orderType: null,
});
const searchFormRef = ref();
const onSubmit = () => {
  _comboList();
};
const onReset = (formEl) => {
  formEl.resetFields();
  pageSize.value = 10;
  currentPage.value = 1;
  _comboList();
};
const currentPage = ref(1);
const pageSize = ref(10);
const total = ref(0);
const handleSizeChange = (val) => {
  pageSize.value = val;
  _comboList();
};
const handleCurrentChange = (val) => {
  currentPage.value = val;
  _comboList();
};
const _comboList = () => {
  service.post('/health/web/healthOrder/page', {
    pageSize: pageSize.value || null,
    pageNo: currentPage.value || null,
    startDate: formInline.date && formInline.date.length > 1 ? formInline.date[0] : null,
    endDate: formInline.date && formInline.date.length > 1 ? formInline.date[1] : null,
    orderNo: formInline.orderNo,
    packageName: formInline.packageName,
    orderStatus: formInline.orderStatus,
    orderType: formInline.orderType,
  })
    .then(data => {
      console.log(data)
      if (data.data.code == 200) {
        tableData.value = data.data.data.records
        total.value = data.data.data.total
      }
    })
    .catch(err => {
      ElMessage({
        message: err.message,
        type: "error",
      });
    })
};
// 导出
const orderExportBtn = () => {
  service({
    method: 'post',
    url: '/health/web/healthOrder/exportOrder',
    data: {},
    responseType: 'blob'
  })
    .then(data => {
      console.log(data)
      // 处理返回的 blob 数据，进行下载等操作
      const blob = new Blob([data.data], { type: 'application/vnd.ms-excel' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = "订单报表.xlsx";
      link.click();
      URL.revokeObjectURL(url);
    })
    .catch(err => {
      ElMessage({
        message: err.message,
        type: "error",
      });
    })
};
// 取消订单
const cancel = (row) => {
  ElMessageBox.confirm("请确认是否取消该订单？", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
    closeOnClickModal: false,
  }).then(() => {
    service({
      method: 'get',
      url: '/health/web/healthOrder/webCancel?orderId=' + row.id,
    }).then(data => {
      ElMessage({
        message: "取消成功，订单状态变更存在延迟，请关注",
        type: "success",
      });
    }).catch(err => {
      ElMessage({
        message: err.message,
        type: "error",
      });
    })
  }).catch(() => {

  })
};

onMounted(() => {
  _comboList();
});

const handleToggle = (row) => {
  row.expanded = !row.expanded;
};
</script>
<style scoped lang="scss">
.flex {
  display: flex;
}

.items-center {
  align-items: center;
}

.justify-center {
  justify-content: center;
}

.success {
  color: #02bc6c;
}

.red {
  color: #da0f0f;
}

.blue {
  color: #0051b7;
}

.yellow {
  color: #e6a23c
}
</style>
